import { render, staticRenderFns } from "./OtherStylists.vue?vue&type=template&id=8e2975d8"
import script from "./OtherStylists.vue?vue&type=script&lang=js"
export * from "./OtherStylists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports